<template>
  <b-container
    fluid
    class="w-100 m-0 p-0"
    @mouseover="onHover"
    @mouseleave="onLeave"
  >
    <b-row
      align-v="center"
      class="w-100"
    >
      <b-col class="m-0 p-0">
        <DropdownConfiguration
          :controller="FitType"
          class="m-0"
        />
      </b-col>
      <b-col
        class="m-0 p-0"
        cols="1"
      >
        <b-button
          size="sm"
          variant="outline-primary"
          class="m-0 p-0"
          @click="coefExpanded=!coefExpanded"
        >
          <b-icon
            v-if="coefExpanded"
            aria-label="More"
            icon="caret-up"
          />
          <b-icon
            v-else
            aria-label="More"
            icon="caret-down"
          />
        </b-button>
      </b-col>
    </b-row>
    <b-row class="w-100">
      <b-collapse
        v-model="coefExpanded"
        class="ml-5 mb-2 expanded-info p-1"
      >
        <SelectedFit
          :sectionconfig="sectionconfig"
          :fitname="fitname"
          :selectedvalue="FitType.textSelection"
        />
      </b-collapse>
    </b-row>
  </b-container>
</template>

<script>
import SelectedFit from './SelectedFit'
import DropdownConfiguration from '../../DropdownConfiguration'
import {comboBoxConfCtrller, hiddenConfCtrller} from '@/assets/classes/configuration.js'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { mapActions } from 'vuex'

const rootContextFolder = 'FitSelection'

export default {
  name: 'FitSelection',
  components:{
    SelectedFit,
    DropdownConfiguration,
  },
  props: {
    sectionconfig:{
      type:String,
      required: true
    },
    fitname:{
      type:String,
      required: true
    }
  },
  data() {
    return {
      elementsConfig:[],
      FitType:new comboBoxConfCtrller(`${ConfigName.BaseCurveFit}.{0}.Model`,
        [
          {text:'Linear',value:'y~x+1'},
                    {text: 'Quadratic', value: 'y~x^2+x+1'},
                    {text: 'Square root', value: 'y~x^0.5+1'},
          {text:'Inverse square root',value:'y~x^(-1/2)+1'},
          {text:'Semilog x',value:'y~log10(x)+1'},
          {text:'Semilog y',value:'log10(y)~x+1'},
          {text:'Double log',value:'log10(y)~log10(x)+1'},
          {text:'Exponential x',value:'y~exp(x)+1'},
          {text:'Exponential y',value:'exp(y)~x+1'},
          {text:'Michaelis-Menten',value:'1/y~1/x+1'},
        ],'Fit formula',0,rootContextFolder+'FitType'
      ),
      customCoefs: new hiddenConfCtrller(`${ConfigName.BaseCurveFit}.{0}.CustomCoefs`,[]),
      coefExpanded: true,
      routeContextHelp:'' //Route for the Context Help it depends on the Section
    }
  },
  computed:{
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      };
    }
  },
  mounted() {
    this.elementsConfig = [
      this.FitType,
      this.customCoefs
    ]
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.formatKeyValue(this.fitname))
    this.elementsConfig.forEach(conf=>conf.setParent(this))
    this.routeContextHelp=`ReportViewer/Studies/${this.sectionconfig}/${rootContextFolder}`
    this.$watch(
      'FitType.textSelection',
      () => {
        this.clearCoefficients()
      }
    );
  },
  methods: {
    ...mapActions([
      'setContextOnHover',
      'setContextFixElement'
    ]),
    onHover() {
      this.setContextOnHover(this.routeContextHelp)
    },
    onLeave(){
      this.setContextOnHover(null)
    },
    clearCoefficients(){
      this.customCoefs.setValue([])
    }
  },
}
</script>

<style>
.short-message{
  font-weight: bold;
  font-size: 0.9rem;
}
</style>
